import { IRoom, IStaySectionsEditor } from '@smarttypes/hotel';
import { get, isBoolean } from 'lodash';

export const ORDER_BUTTON_SECTION_KEYS = [
  'parking',
  'breakfast',
  'cleaning',
  'earlyCheckIn',
  'lateCheckOut',
  'amenities',
  'transfer',
] as const;

export type OrderButtonSectionKey = (typeof ORDER_BUTTON_SECTION_KEYS)[number];

export type OrderButtonsConfig = Partial<Record<OrderButtonSectionKey, boolean | null>>;

export function getOrderButtonHighlight(apartment: IRoom, key: OrderButtonSectionKey): boolean {
  return get(apartment, `config.orderButtons.${key}`) === true;
}

export function buildOrderButtonsFromEditor(staySections?: IStaySectionsEditor): OrderButtonsConfig {
  return ORDER_BUTTON_SECTION_KEYS.reduce((acc, key) => {
    const highlight = staySections?.[key]?.highlight;
    acc[key] = isBoolean(highlight) ? highlight : null;
    return acc;
  }, {} as OrderButtonsConfig);
}

export function orderButtonsToMongoSet(orderButtons: OrderButtonsConfig = {}): Record<string, boolean | null> {
  return ORDER_BUTTON_SECTION_KEYS.reduce((acc, key) => {
    acc[`config.orderButtons.${key}`] = orderButtons[key] ?? null;
    return acc;
  }, {} as Record<string, boolean | null>);
}
